export const ORDER_TYPE_DESC = "desc";
export const ORDER_TYPE_ASC = "asc";
export const ORDER_TYPE = "orderType";
export const ORDER_BY = "orderBy";
export const CREATED_AT_FIELD = "createdAt";
